import { apiSlice } from '../../api/apiSlice';
import * as constants from '../../constants';

export const managerDashboardSlice = apiSlice.injectEndpoints({
    endpoints: (builder: any) => ({
        getPayoutApprovals: builder.query({
            query: (arg: any) => {
                const { employeenumber, year, month, scorecardVersionId, typeOfApproval,managerNumber,isUnapproved } = arg;
                return {
                    url: constants.PAYOUT_APPROVALS,
                    params: { employeenumber, year, month, scorecardVersionId, typeOfApproval,managerNumber,isUnapproved },
                };
            },
            providesTags: ['Approvals'],            
            // keepUnusedDataFor:0,
        }),
        updateDisqualifyApproval: builder.mutation({
            query: (arg: any) => ({
                url: constants.UPDATE_DISQUALIFY_APPROVAL,
                method: 'PUT',
                body: arg,
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
            }),
            invalidatesTags: ['Approvals'],
        }),
        updateApprovalStatus: builder.mutation({
            query: (arg: any) => ({
                url: constants.UPDATE_APPROVAL_STATUS,
                method: 'PUT',
                body: arg,
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
            }),
            invalidatesTags: ['Approvals'],
        }),
        getPayoutApprovalsExport: builder.query({
            query: (arg: any) => {
                const {  year, month, scorecardVersionId ,scorecardRoleId} = arg;
                return {
                    url: constants.PAYOUT_APPROVALS_EXPORT,
                    params: {  year, month, scorecardVersionId,scorecardRoleId },
                };
            },
            providesTags: ['Approvals'],
        }),
        getScorecardBonusPenaltyData: builder.query({
            query: (arg: any) => {
                const {  year, month, scorecardVersionId} = arg;
                return {
                    url: constants.GET_SCORECARD_BONUS_PENALTY_DATA,
                    params: {  year, month, scorecardVersionId },
                };
            },
        }),
        getManagerRecentApprovalsCount: builder.query({
            query: (arg: any) => {
                const { employeeNumber} = arg;
                return {
                    url: constants.GET_MANAGER_RECENT_APPROVER_STATUS,
                    params: {  employeeNumber },
                };
            },
        }),
    }),
});

export const {
    useGetPayoutApprovalsQuery,
    useUpdateDisqualifyApprovalMutation,
    useUpdateApprovalStatusMutation,
    useGetPayoutApprovalsExportQuery,
    useGetScorecardBonusPenaltyDataQuery,
    useGetManagerRecentApprovalsCountQuery,
} = managerDashboardSlice;
